module.exports = __webpack_public_path__ + "static/img/son9_active.96852ca3.png";